import {
  GETSETTLEMENTREPORTPARTNER_SUCCESS,
  GETSETTLEMENTREPORTPARTNER_FAILED,
  RESET_GETSETTLEMENTREPORTPARTNER,
  LOADING_GETSETTLEMENTREPORTPARTNER,
  NETWORK_ERROR_GETSETTLEMENTREPORTPARTNER,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETSETTLEMENTREPORTPARTNER:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETSETTLEMENTREPORTPARTNER_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETSETTLEMENTREPORTPARTNER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETSETTLEMENTREPORTPARTNER:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETSETTLEMENTREPORTPARTNER:
      return (state = initialState);
    default:
      return state;
  }
};
